/**
 * @generated SignedSource<<e9b4fa932754353efda170ea030b03d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CalendarTeamEventDeletedSubscription$variables = {
  calendarIds: ReadonlyArray<string>;
  connections: ReadonlyArray<string>;
};
export type CalendarTeamEventDeletedSubscription$data = {
  readonly calendarEventDeleted: {
    readonly calendarEvent: {
      readonly id: string;
    };
  } | null;
};
export type CalendarTeamEventDeletedSubscription = {
  response: CalendarTeamEventDeletedSubscription$data;
  variables: CalendarTeamEventDeletedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "calendarIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "calendarIds",
    "variableName": "calendarIds"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CalendarTeamEventDeletedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CalendarEventDeletedPayload",
        "kind": "LinkedField",
        "name": "calendarEventDeleted",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CalendarEvent",
            "kind": "LinkedField",
            "name": "calendarEvent",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CalendarTeamEventDeletedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CalendarEventDeletedPayload",
        "kind": "LinkedField",
        "name": "calendarEventDeleted",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CalendarEvent",
            "kind": "LinkedField",
            "name": "calendarEvent",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteEdge",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  }
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "27ec8a41a7d63902b87abf1f45569a1f",
    "id": null,
    "metadata": {},
    "name": "CalendarTeamEventDeletedSubscription",
    "operationKind": "subscription",
    "text": "subscription CalendarTeamEventDeletedSubscription(\n  $calendarIds: [ID!]!\n) {\n  calendarEventDeleted(calendarIds: $calendarIds) {\n    calendarEvent {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e2b6dfd475f79c4cdf732294e5ec68be";

export default node;
